import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


import {language} from "../language/get";

const lan = language();



export const constantRoutes = [
    
    
]



const createRouter = () =>
  new Router({
      // mode: "history",
      routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

router.$addRoutes = params => {
    router.matcher = new Router({ scrollBehavior: () => ({ y: 0 }) }).matcher;
    router.addRoutes(params);
};
export default router;


